import React from 'react';
import { Container } from './Option.styled';
const Option = (props) => {
    return React.createElement(Container, Object.assign({}, props), props.children);
};
Option.propTypes = {};
Option.defaultProps = {};
export default Option;
//# sourceMappingURL=Option.js.map